<template>
  <v-container fluid style="height: 100%;">
    <v-row align="start" justify="center">
      <v-col lg="8" md="8" sm="12" xs="12" cols="12">
        <v-row>
          <v-col lg="12" style="font-weight: 100;">
            <h4 style="font-weight: 100;">{{ $t("editCarrier").toUpperCase() }}</h4>
          </v-col>
        </v-row>
        <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
        <v-row>
          <v-col lg="6" md="6" sm="12" cols="12">
            <v-col lg="10" sm="12" md="12" style="padding: 5px;">
              <v-autocomplete
                :items="dealers"
                item-text="Name"
                item-value="DealerId"
                v-model="dealerSelected"
                :search-input.sync="searchDealer"
                :label="$t('dealer')"
                outlined
                :color="colorTheme"
                :disabled="dealersDisabled"
                clearable
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t("noResults") }} : "{{
                        searchDealer
                        }}".
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col lg="10" sm="12" md="12" style="padding: 5px;">
              <v-autocomplete
                :items="clients"
                item-text="Name"
                item-value="ClientId"
                v-model="clientSelected"
                :search-input.sync="searchClient"
                :label="$t('client')"
                outlined
                :color="colorTheme"
                :disabled="clientsDisabled"
                clearable
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t("noResults") }} : "{{
                        searchClient
                        }}".
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col lg="10" sm="12" md="12" style="padding: 5px;">
              <v-autocomplete
                :items="accounts"
                item-text="Name"
                item-value="AccountId"
                v-model="accountSelected"
                :search-input.sync="searchAccount"
                :label="$t('account')"
                outlined
                :color="colorTheme"
                :disabled="accountsDisabled"
                clearable
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t("noResults") }} : "{{
                        searchAccount
                        }}".
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
          </v-col>
          <v-col lg="6" md="6" sm="12" cols="12">
            <v-container>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-text-field
                      :label="$t('name')"
                      v-model="TradeName"
                      :rules="TradeNameRules"
                      :color="colorTheme"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-text-field
                      :label="$t('businessName')"
                      v-model="BusinessName"
                      :rules="BusinessNameRules"
                      :color="colorTheme"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-text-field
                      :label="$t('address')"
                      v-model="Address"
                      :rules="AddressRules"
                      :color="colorTheme"
                      outlined
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-select
                      :label="$t('typeOfServices')"
                      :items="listServiceType"
                      item-text="Name"
                      item-value="Id"
                      :color="colorTheme"
                      v-model="ServiceType"
                      outlined
                      required
                    ></v-select>
                  </v-col>
                  <v-col lg="6" md="6" sm="12" cols="12">
                    <v-select
                      :label="$t('modality')"
                      :items="listModality"
                      item-text="Name"
                      item-value="Id"
                      :color="colorTheme"
                      v-model="Modality"
                      outlined
                      required
                    ></v-select>
                  </v-col>
                  <v-col lg="5" md="5" sm="12" cols="12">
                    <v-select
                      :label="$t('selectContact')"
                      :items="contactMediaType"
                      item-text="Name"
                      item-value="Id"
                      :color="colorTheme"
                      v-model="Type"
                      outlined
                      required
                    ></v-select>
                  </v-col>
                  <v-col lg="5" md="5" sm="12" cols="12">
                    <v-text-field
                      :color="colorTheme"
                      :label="$t('contact')"
                      v-model="value"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col lg="2" md="2" sm="12" cols="12">
                    <v-btn
                      :color="colorTheme"
                      text
                      small
                      v-on:click="addContact()"
                    >{{ $t("add").toUpperCase() }}</v-btn>
                  </v-col>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-combobox
                      v-model="TypeValues"
                      small-chips
                      cleareable
                      outlined
                      multiple
                      @keyup.space="alert()"
                      append-icon
                      :color="colorTheme"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          class="white--text"
                          :color="colorTheme"
                          @click="data.select"
                          @click:close="remove(data.item)"
                        >
                          <v-icon left>{{ data.item.icon }}</v-icon>
                          {{ data.item.Value }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-row align="center" justify="center">
          <v-col lg="2">
            <v-btn
              :color="colorTheme"
              class="white--text"
              v-on:click="cancelCarrier()"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
          </v-col>
          <v-col lg="2">
            <v-btn
              :color="colorTheme"
              class="white--text"
              v-on:click="editCarrier()"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "editCarrier",
  data() {
    return {
      searchDealer: "",
      searchClient: "",
      searchAccount: "",
      Id: 0,
      TradeName: "",
      TradeNameRules: [v => !!v || this.$t("required")],
      BusinessName: "",
      BusinessNameRules: [v => !!v || this.$t("required")],
      Address: "",
      AddressRules: [v => !!v || this.$t("required")],
      ServiceType: 0,
      Modality: 0,
      Type: 0,
      value: "",
      valid: true,
      TypeValues: []
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setTitle", this.$t("traffic"));
    this.$store.commit("setPageHeader", ["CARRIERS", "", "", "", true]);
    this.$store.commit("setValuesReportsPage");
    this.$store.dispatch("getCatalog");
    //console.log(this.$store.state.editCarrier);
    this.Id = this.$store.state.editCarrier.Id;
    this.TradeName = this.$store.state.editCarrier.TradeName;
    this.BusinessName = this.$store.state.editCarrier.BusinessName;
    this.Address = this.$store.state.editCarrier.Address;
    this.ServiceType = this.$store.state.editCarrier.ServiceTypeId;
    this.Modality = this.$store.state.editCarrier.ModalityId;
    if (this.$store.state.editCarrier.Contacts.length > 0) {
      this.TypeValues = this.$store.state.editCarrier.Contacts;
    }
  },
  computed: {
    ...mapState([
      "colorTheme",
      "dealers",
      "dealersDisabled",
      "clients",
      "clientsDisabled",
      "accounts",
      "accountsDisabled",
      "listServiceType",
      "listModality",
      "contactMediaType",
      "valueDeterminate"
    ]),
    dealerSelected: {
      get: function() {
        return this.$store.state.dealerSelected;
      },
      set: function(val) {
        if (val != undefined) {
          if (val != this.$t("all")) {
            var delaerselected = this.$store.getters.getAccessFilter([
              this.$store.state.dealers,
              val,
              "DealerId"
            ]);
            this.$store.commit("filterSelected", [
              delaerselected,
              this.$t("all"),
              this.$t("all"),
              this.$t("all")
            ]);
            this.$store.dispatch("getFilterAccountCatalog", [
              "clients?DealerId=" + val,
              "Dealer"
            ]);
            this.$store.commit("deletAllVehicles");
          } else {
            this.$store.commit("filterSelected", [
              val,
              this.$t("all"),
              this.$t("all"),
              this.$t("all")
            ]);
            this.$store.commit("deletAllVehicles");
          }
        } else {
          this.$store.commit("filterSelected", [
            val,
            this.$t("all"),
            this.$t("all"),
            this.$t("all")
          ]);
          this.$store.commit("filtersEnabled", [false, true, true, true]);
          this.$store.commit("deletAllVehicles");
        }
      }
    },
    clientSelected: {
      get: function() {
        return this.$store.state.clientSelected;
      },
      set: function(val) {
        if (val != undefined) {
          if (val != this.$t("all")) {
            var clientselected = this.$store.getters.getAccessFilter([
              this.$store.state.clients,
              val,
              "ClientId"
            ]);
            this.$store.commit("filterSelected", [
              this.$store.state.dealerSelected,
              clientselected,
              this.$t("all"),
              this.$t("all")
            ]);
            this.$store.dispatch("getFilterAccountCatalog", [
              "accounts?DealerId=" +
                this.$store.state.dealerSelected.DealerId +
                "&ClientId=" +
                val,
              "Client"
            ]);

            this.$store.commit("deletAllVehicles");
          } else {
            this.$store.dispatch("getVehiclesCatalog", [
              "&did=" + this.$store.state.dealerSelected.DealerId,
              false
            ]);
            this.$store.commit("filterSelected", [
              this.$store.state.dealerSelected,
              val,
              this.$t("all"),
              this.$t("all")
            ]);
            this.$store.commit("deletAllVehicles");
          }
        } else {
          this.$store.commit("filterSelected", [
            this.$store.state.dealerSelected,
            val,
            this.$t("all"),
            this.$t("all")
          ]);
          this.$store.commit("filtersEnabled", [false, false, true, true]);
          this.$store.commit("deletAllVehicles");
        }
      }
    },
    accountSelected: {
      get: function(val) {
        return this.$store.state.accountSelected;
      },
      set: function(val) {
        if (val != undefined) {
          if (val != this.$t("all")) {
            var accountselected = this.$store.getters.getAccessFilter([
              this.$store.state.accounts,
              val,
              "AccountId"
            ]);
            this.$store.commit("filterSelected", [
              this.$store.state.dealerSelected,
              this.$store.state.clientSelected,
              accountselected,
              this.$t("all")
            ]);
            this.$store.dispatch("getFilterAccountCatalog", [
              "vehiclegroups?DealerId=" +
                this.$store.state.dealerSelected.DealerId +
                "&ClientId=" +
                this.$store.state.clientSelected.ClientId +
                "&AccountId=" +
                val,
              "Account"
            ]);
            this.$store.commit("deletAllVehicles");
          } else {
            this.$store.dispatch("getVehiclesCatalog", [
              "&did=" +
                this.$store.state.dealerSelected.DealerId +
                "&cid=" +
                this.$store.state.clientSelected.ClientId,
              false
            ]);
            this.$store.commit("filterSelected", [
              this.$store.state.dealerSelected,
              this.$store.state.clientSelected,
              val,
              this.$t("all")
            ]);
            this.$store.commit("deletAllVehicles");
          }
        } else {
          this.$store.commit("filterSelected", [
            this.$store.state.dealerSelected,
            this.$store.state.clientSelected,
            val,
            this.$t("all")
          ]);
          this.$store.commit("filtersEnabled", [false, false, false, true]);
          this.$store.commit("deletAllVehicles");
        }
      }
    }
  },
  methods: {
    cancelCarrier() {
      this.$refs.form.reset();
      this.$router.replace({ name: "carriers" });
    },
    editCarrier() {
      if (this.$refs.form.validate()) {
        this.$store.commit("setAccount", false);
        var items = {
          Id: this.Id,
          TradeName: this.TradeName,
          BusinessName: this.BusinessName,
          Address: this.Address,
          ServiceType: this.ServiceType,
          Modality: this.Modality,
          Contacts: this.TypeValues
        };
        this.$store.dispatch("EditCarrier", items);
        this.$refs.form.reset();
        this.$router.replace({ name: "carriers" });
      }
    },
    addContact() {
      var icon = "";
      if (this.Type == 1) {
        icon = "mdi-cellphone";
        var valid = this.ValidatePhone(this.value);
        if (valid) {
          var item = {
            Type: this.Type,
            icon: icon,
            Value: this.value
          };
          this.TypeValues.push(item);
          this.Type = 0;
          this.value = "";
        } else {
          alert("No es un numero");
        }
      } else if (this.Type == 2) {
        icon = "mdi-email";
        var valid = this.ValidateEmail(this.value);
        if (valid) {
          var item = {
            Type: this.Type,
            icon: icon,
            Value: this.value
          };
          this.TypeValues.push(item);
          this.Type = 0;
          this.value = "";
        } else {
          alert("No es un correo");
        }
      } else {
        var item = {
          Type: this.Type,
          icon: icon,
          Value: this.value
        };
        this.TypeValues.push(item);
        this.Type = 0;
        this.value = "";
      }
    },
    remove(item) {
      const index = this.TypeValues.map(function(e) {
        return e.Value;
      }).indexOf(item.Value);
      if (index >= 0) this.TypeValues.splice(index, 1);
    },
    ValidateEmail(mail) {
      var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (mail.match(mailformat)) {
        return true;
      }
      return false;
    },
    ValidatePhone(number) {
      if (number.match(/^\d+/)) {
        return true;
      }
      return false;
    }
  }
};
</script>
